export default {
    DetailsOfThirdPartySalesOrder: {
        typeE: 'Error Type',
        reasonE: 'Error Details',
        Suggestions: 'Action required',
        Order: 'Order details',
        log: 'Operation log',
        Circulation: 'Flow status',
        need: 'No flow required',
        progress: 'Order progress',
        Normal: 'Normal flow',
        party: 'The third-party order has been successfully converted to an internal sales order for delivery flow',
        Suspend: 'Suspended flow',
        Reason: 'Reason',
        information: 'Order information',
        Trantypesaction: 'Order Type',
        number: 'Customer Order No.',
        Internal: 'CSG Order No.',
        Platform: 'Platform status',
        Refund: 'Refund status',
        Sales: 'Store',
        employee: 'Sales Staff',
        placement: 'Order time',
        pulling: 'Order generation time',
        dodgeCompany: 'Shipping Provider Company',
        dodgeAccount: 'Shipping Provider Account',
        amount: 'Order amount',
        Total: 'Total product amount',
        Yuan: 'RMB',
        Goods: 'Discount amount',
        Discount: 'Merchant bears the discount amount',
        Preferential: 'Third party bears the discount amount',
        receivable: 'Total receivable amount',
        Freight: 'Shipping cost',
        Customer: 'Customer service adjustment amount',
        Remarks: 'Remarks',
        comments: "Buyer's Comments",
        Merchant: "Merchant's Comments",
        Receiving: 'Delivery information',
        Method: 'Pickup method',
        store: 'Pickup store',
        nickname: 'Buyer nickname',
        Consignee: 'Recipient',
        Mobile: 'Mobile',
        Address: 'Address',
        Paymentinformation: 'Payment information',
        Paymentmethod: 'Payment method',
        Paymentstatus: 'Payment status',
        Paymenttime: 'Payment time',
        actual: 'Buyer actual payment amount',
        Invoice: 'Invoice information',
        No: 'No invoicing application',
        Commodity: 'Product list',

        Serial: 'Count',
        Sub: 'Sub-Order No.',
        Notice: 'Platform status',
        Issue: 'Processing status',
        status: 'Refund status',
        image: 'Product image',
        Number: 'Platform product name',
        item: 'Platform product ID',
        specification: 'Platform specification ID',
        Platformitem: 'Platform product code',
        Platformcode: 'Platform specification code',
        Platformname: 'Platform specification name',
        Internalcode: 'Internal SKU code',
        Whether: 'Whether it is a gift',
        Quantity: 'Quantity',
        Unit: 'Platform product unit price',
        price: 'Platform product total price',
        amountgoods: 'Total discount amount of products',
        Adjustment: 'Adjustment amount',
        Allocate: 'Share the third-party discount',
        discounts: 'Share the merchant discount',
        Allocated: 'Freight apportionment',
        paid: 'Amount paid',
        Note: 'Refund Order No.',
        Refundamount: 'Refund amount',
        Refundquantity: 'Refund quantity',
        Totalproducts: 'Total number of products',
        Totalnumber: 'Total number of SKUs',
        temporarily: 'None',
    }
};
